import { SIGN_ERROR_CODES } from '@/constants/sign';
import { DocumentService } from '@/services/DocumentService';
import { SigningErrorResponse } from '@/types/sign';
import { AxiosError } from 'axios';
import { includes } from 'lodash';
import { useTranslation } from 'react-i18next';

export const useGetSigningError = <TError extends SigningErrorResponse>({
  error,
  isCancelLoading,
  isSuccess,
  isSigning,
}: {
  error: AxiosError<TError> | null;
  isCancelLoading: boolean;
  isSuccess: boolean;
  isSigning: boolean;
}) => {
  const { t } = useTranslation();
  const documentService = new DocumentService({ t });

  const errorCode = error?.response?.data?.error_code;
  const isPollingData =
    !isCancelLoading &&
    !isSuccess &&
    !!error &&
    !isSigning &&
    !includes(
      [
        SIGN_ERROR_CODES.PHONE_NUMBER_ERROR,
        SIGN_ERROR_CODES.PERSONAL_NUMBER_ERROR,
        SIGN_ERROR_CODES.VERIFICATION_METHOD_ERROR,
      ],
      errorCode
    );

  const errorMessage =
    errorCode && documentService.signingErrorMessagesMapper[errorCode];
  return {
    isPollingData,
    errorMessage,
  };
};
